import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowRight } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Image from '../Image';
import css from './Block.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Block = function Block(_ref) {
  var title = _ref.title,
      image = _ref.image,
      description = _ref.description,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("a", {
    href: url,
    className: css.root,
    target: "_blank",
    rel: "noopener noreferrer",
    children: [/*#__PURE__*/_jsx("div", {
      className: css.iconWrap,
      children: /*#__PURE__*/_jsx("div", {
        className: css.inner,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          alt: "".concat(title, " Logo"),
          sizes: [222]
        }))
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.textWrap,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.summary,
        children: description
      }), /*#__PURE__*/_jsx("div", {
        className: css.readMoreWrap,
        children: /*#__PURE__*/_jsxs("div", {
          className: css.readMore,
          children: ["Read More", /*#__PURE__*/_jsx(ArrowRight, {})]
        })
      })]
    })]
  });
};

Block.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired,
  url: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(Block);